import React, { useState, useEffect } from 'react';
import { Table, Tag, Input } from 'antd';
// import { getVendors } from '../../api/NodeServer';
import { getVendors } from '../../api/VendorsContainer';

const { Search } = Input;

const VendorList = ({
    handleVendorClick
}) => {
    const [searchText, setSearchText] = useState('');
    const [sortedInfo, setSortedInfo] = useState({});
    const [vendorData, setVendorData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getVendors();
            setVendorData(data);
        };

        fetchData();
    }, []);

    const columns = [
        {
            title: 'Vendor Name',
            dataIndex: 'vendor',
            key: 'vendor',
            sorter: (a, b) => a.vendor.localeCompare(b.vendor),
            sortOrder: sortedInfo.columnKey === 'vendor' && sortedInfo.order,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: (a, b) => {
                // Provide default values for null or undefined types
                const typeA = a.type || '';
                const typeB = b.type || '';

                return typeA.localeCompare(typeB);
            },
            sortOrder: sortedInfo.columnKey === 'type' && sortedInfo.order,
        },
        {
            title: 'Recurring',
            dataIndex: 'recurring',
            key: 'recurring',
            render: (recurring) => (
                <Tag color={recurring ? 'green' : 'gray'}>
                    {recurring ? 'Yes' : 'No'}
                </Tag>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <Tag color="red" key={record.id}>
                    Delete
                </Tag>
            ),

        }
    ];

    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter); // Update sortedInfo state with the current sorting information
    };

    const filteredData = vendorData?.filter((vendor) =>
        Object.values(vendor).some((value) => {
            // Check if the value is null or undefined before converting it to a string
            if (value === null || value === undefined) {
                return false;
            }
            return value.toString().toLowerCase().includes(searchText.toLowerCase());
        })
    );

    return (
        <div>
            <div className="list-panel-heading">
                <div>
                    <h2>Vendor List</h2>
                    <p>{filteredData.length} vendors shown</p>
                </div>
                <Search
                    allowClear
                    placeholder="Search vendors"
                    className="list-search"
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>
            <div className="data-table-shell">
                <Table
                    className="management-table"
                    columns={columns}
                    dataSource={filteredData}
                    onChange={handleTableChange}
                    onRow={(record) => ({ onClick: () => handleVendorClick(record) })}
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                />
            </div>
        </div>
    );
};

export default VendorList;
